export const MAX_HEIGHT = 2464
export const MAX_WIDTH = 1179
export const FRAME_HORIZONTAL_GAP = 49.5
export const FRAME_VERTICAL_GAP = 52.2
export const STANDARD_GLAZING_HEIGHT = 1468
export const MAX_ZOOM = 1.6
